import BasicCard from "../../../../../components/card/basiccard/BasicCard";
import Heading from "../../../../../components/heading/Heading";
import { HEADING } from "../../../../../components/heading/constants/constants";
import Icons from "../../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../../components/icons/constants";
import styles from './BulkUploadSuccess.styles'
import commonStyles from '../../AddRecipient.styles'
import Button from "../../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../../components/button/constants";
import { RECIPIENT_SECTION_ROUTES } from "../../../../recipientssection/constants";
import { componentKey } from "../BulkUploadSlice";
import { useDispatch, useSelector } from "react-redux";
import { downloadErroReport } from "../BulkUploadSaga";
import { PAGE_STATE } from "../../../../constants/constants";
import { componentKey as dataLoaderComponentKey } from "../../../../loaders/dataloader/DataLoaderSlice"
import { componentKey as addRecipientComponentKey, setMethodType } from "../../AddRecipientSlice"
import { CHOOSE_METHOD_CARD_NAMES } from "../../../addpayernew/createone/getmethod/constants/constants";
import { componentKey as authenticationKey } from "../../../../authentication/AuthenticationSlice";
import { QUERY_PARAMS } from "../../../../formssection/constants";
import useTxSearchParams from "../../../../../../libs/txsearchparams/TxSearchParamsHook";
import useTxNavigate from "../../../../../../libs/txnavigate/TxNavigateHook";

export default function BulkUploadSuccess({ setRefreshStep = () => { } }) {

    const navigate = useTxNavigate();
    const dispatch = useDispatch();
    const [queryParams] = useTxSearchParams();
    const urlPayerId = queryParams.get(QUERY_PARAMS.PAYER_ID);

    const { loadingState } = useSelector((state) => state[addRecipientComponentKey]);
    const { validationStatus } = useSelector((state) => state[componentKey]);
    const { isTaxIdError, success, successfullyAddedPayers, payersWithErrors } = validationStatus;

    const { signedInUser } = useSelector((state) => state[authenticationKey]);

    return (
        <>
            {loadingState.state != PAGE_STATE.LOADING && <div style={commonStyles.addPayerSuccessContainer}>

                <BasicCard alignItems="center" customStyles={styles.bacisCard}>
                    <Icons familyName="vec" iconName={VEC_ICON_NAME.BULK_PAYER_ADDED_SUCCESS} />

                    {isTaxIdError &&
                        <>
                            <Heading type={HEADING.H1} customStyle={commonStyles.cardHeading}>
                                So sorry, {signedInUser?.FirstName ? signedInUser.FirstName : signedInUser?.LastName}!
                            </Heading>
                            <Heading type={HEADING.H2} customStyle={commonStyles.cardSubHeading}>
                                We have not added any recipients because some recipients in your sheet have missing Tax IDs. Please ensure all Tax IDs are filled in and upload the sheet again.
                            </Heading>
                        </>
                    }

                    {success &&
                        <>
                            <Heading type={HEADING.H1} customStyle={commonStyles.cardHeading}>Congratulations, {signedInUser?.FirstName ? signedInUser.FirstName : signedInUser?.LastName}!</Heading>
                            {validationStatus?.message && <Heading type={HEADING.H2} customStyle={commonStyles.cardSubHeading}>{validationStatus.message}</Heading>}
                            <Heading type={HEADING.H2} customStyle={commonStyles.cardSubHeading}>All the {successfullyAddedPayers ? successfullyAddedPayers : ""} recipients got processed.</Heading>
                        </>
                    }

                    {!success && !isTaxIdError &&
                        <>
                            <Heading type={HEADING.H1} customStyle={commonStyles.cardHeading}>
                                So sorry, {signedInUser?.FirstName ? signedInUser.FirstName : signedInUser?.LastName}!
                            </Heading>
                            <Heading type={HEADING.H2} customStyle={commonStyles.cardSubHeading}>
                                {successfullyAddedPayers == 0 ?
                                    `We have not added any recipients because there are errors in your sheet. None of the payer records are valid.` :
                                    `We have not added any recipients because there are some errors in your sheet. Only ${successfullyAddedPayers || '0'} payer records are valid.`
                                }
                            </Heading>
                        </>
                    }

                    <div style={commonStyles.grayBorder}></div>

                    {(payersWithErrors > 0) && <>
                        <label style={commonStyles.payerName}>
                            There are <span style={styles.errorText}>{payersWithErrors} recipients with errors.</span>
                        </label>

                        <div style={styles.individualPayer} onClick={() => dispatch(downloadErroReport())}>
                            <Icons familyName="vec" iconName={VEC_ICON_NAME.DOWNLOAD_ICON_V2} />
                            <label style={styles.errorReport}>Download error report</label>
                        </div>
                    </>}

                </BasicCard>

                <p style={commonStyles.questionText}>What would you like to do next?</p>

                <div style={commonStyles.buttonsContainer}>
                    <Button type={BUTTON_TYPE.PRIMARY} style={commonStyles.button} onClickCb={() => navigate(`/${RECIPIENT_SECTION_ROUTES.RECIPIENT}?${QUERY_PARAMS.PAYER_ID}=${urlPayerId}`)}>View added recipients</Button>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        style={commonStyles.button}
                        onClickCb={() => {
                            navigate(`/${RECIPIENT_SECTION_ROUTES.RECIPIENT}/${RECIPIENT_SECTION_ROUTES.ADD}`)
                            dispatch(setMethodType(CHOOSE_METHOD_CARD_NAMES.CREATE_ONE))
                            setRefreshStep(0)
                        }}
                    >
                        Add another recipients
                    </Button>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        style={commonStyles.button}
                        onClickCb={() => navigate(`/`)}
                    >
                        Go to dashboard
                    </Button>
                </div>
            </div>}
        </>
    )
}
